import { useState, useEffect } from 'react';
import { AuthProvider, useAuth } from './lib/auth';
import { LoginPage } from './pages/LoginPage';
import { DashboardLayout } from './components/DashboardLayout';
import { DashboardPage } from './pages/DashboardPage';
import { MembersPage } from './pages/MembersPage';
import { FinancesPage } from './pages/FinancesPage';
import { EventsPage } from './pages/EventsPage';
import { CommunicationsPage } from './pages/CommunicationsPage';
import { SettingsPage } from './pages/SettingsPage';
import { ImportPage } from './pages/ImportPage';
import { WebsitePage } from './pages/WebsitePage';
import { MediaPage } from './pages/MediaPage';
import { GabbaiPage } from './pages/GabbaiPage';
import { HighHolidaysPage } from './pages/HighHolidaysPage';
import { SchoolPage } from './pages/SchoolPage';
import { CemeteryPage } from './pages/CemeteryPage';

function AppRoutes() {
  const { user, loading } = useAuth();
  const [currentPage, setCurrentPage] = useState('dashboard');

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (!user) {
    return <LoginPage />;
  }

  const renderPage = () => {
    switch (currentPage) {
      case 'members':
        return <MembersPage />;
      case 'finances':
        return <FinancesPage />;
      case 'events':
        return <EventsPage />;
      case 'communications':
        return <CommunicationsPage />;
      case 'website':
        return <WebsitePage />;
      case 'media':
        return <MediaPage />;
      case 'import':
        return <ImportPage />;
      case 'gabbai':
        return <GabbaiPage />;
      case 'high-holidays':
        return <HighHolidaysPage />;
      case 'school':
        return <SchoolPage />;
      case 'cemetery':
        return <CemeteryPage />;
      case 'settings':
        return <SettingsPage />;
      case 'dashboard':
      default:
        return <DashboardPage />;
    }
  };

  return (
    <DashboardLayout currentPage={currentPage} onNavigate={setCurrentPage}>
      {renderPage()}
    </DashboardLayout>
  );
}

export function App() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}
